var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{ref:"canvas",attrs:{"id":"canvas"}})]),_c('button',{ref:"startButton",staticStyle:{"display":"none"},on:{"click":_vm.start}},[_vm._v("Start")])])
}
var staticRenderFns = []

export { render, staticRenderFns }